// extracted by mini-css-extract-plugin
module.exports = {"component":"index_component_2u0LN","content":"index_content_3X4UX","welcome":"index_welcome_3DV4c","prompt":"index_prompt_4wOFV","action":"index_action_3eFZo"};